module.exports = __webpack_public_path__ + "img/user-outline-black.277c769b.svg";